<template>
  <div class="content">
    <div class="background-image-search" style="background-image: url(img/temp/blurred-dark.jpg"></div>
    <!-- /.background-image-search -->

    <base-header class="pb-6" type="none">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
        <b-col xs="12" lg="6" align="right">
          <router-link to="/recipe/add-recipe"><base-button type="secondary" size="sm" class="btn-secondary--alt">Add Recipe</base-button></router-link>
        </b-col>
      </b-row>
    </base-header>

    <RecipeList :searchUri="'recipes/getMyRecipes'" :binder="this.$store.state.recipes.myRecipes" :payload="{ 'userId': this.$store.state.authentication.user.user.id }" :searchQuery="this.searchQuery" />
  
  </div>
</template>
<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import RecipeList from '@/views/Recipe/RecipeList.vue';

export default {
  components: {
    RouteBreadCrumb,
    RecipeList
  },
  data() {
    return {
      "searchQuery": ""
    }
  },
  created() {
    if(this.$route.query.searchQuery){
      this.searchQuery = this.$route.query.searchQuery;
    }
  },
};
</script>
<style>
</style>
